/**
 * Build stamp surface. See docs/release-strategy.md for the format and how
 * QA uses it. The Vite plugin at vite/plugins/version-stamp.ts injects the
 * underlying globals at build time.
 */

import { getLogger } from '@/log';

/** Full build stamp, e.g. `0.4.0-epic.PROD-5993.3+a892e70`. */
export const APP_VERSION: string = __APP_VERSION__;

/**
 * Whether to render the stamp in user-visible UI. Always false in production
 * unless `VITE_SHOW_VERSION=true` was set at build time. The console banner
 * and meta tag stay on regardless.
 */
export const APP_VERSION_VISIBLE: boolean = __APP_VERSION_VISIBLE__;

let bannerLogged = false;

/**
 * Logs the stamp to the console exactly once per page load. Idempotent so
 * tests / HMR don't spam the console. Called from main.tsx on boot.
 * `notice` level so the banner still prints in production builds.
 */
export function logVersionBanner(): void {
    if (bannerLogged) return;
    bannerLogged = true;
    getLogger('app-version').notice(APP_VERSION);
}
